export const testimonials = {
  // SEO
  'seo.title': 'Отзывы Клиентов — Истории Успеха | София и Елена Нутрициологи',
  'seo.description': 'Читайте реальные отзывы наших клиентов о работе с Софией и Еленой. Истории успеха в детской нутрициологии, восстановлении гормонального фона, протоколе FMD и совместном ведении двух экспертов.',
  'seo.keywords': 'отзывы нутрициолог, результаты нутрициологии, истории успеха, детская нутрициология отзывы, протокол FMD результаты, восстановление здоровья',

  // Hero Section
  'hero.title': 'О чем говорят наши клиенты',
  'hero.description': 'Мы продаем не результат — мы продаем эмоцию. Истории тех, кто снова полюбил себя.',

  // Testimonial 1
  'testimonial1.category': 'Детская нутрициология',
  'testimonial1.name': 'Анна М.',
  'testimonial1.text': 'Ребенок начал есть овощи и перестал болеть каждую осень. София — наш ангел! Раньше каждый прием пищи был битвой, а теперь дочка сама просит брокколи. Не верила, что такое возможно.',
  'testimonial1.highlight': 'Ребенок начал есть овощи и перестал болеть',

  // Testimonial 2
  'testimonial2.category': 'Совместное ведение',
  'testimonial2.name': 'Мария К.',
  'testimonial2.text': 'Это был настоящий консилиум! Одна нашла причину в щитовидке, вторая научила меня вкусно есть и наслаждаться процессом. Я чувствую себя на 10 лет моложе. Энергия вернулась, кожа сияет, и я снова полюбила свое отражение в зеркале.',
  'testimonial2.highlight': 'Я чувствую себя на 10 лет моложе',

  // Testimonial 3
  'testimonial3.category': 'Протокол FMD',
  'testimonial3.name': 'Екатерина Л.',
  'testimonial3.text': '5 дней, которые заменили мне отпуск. Легкость, ясный ум и невероятная энергия. Я не ожидала такого эффекта! Чувствую, как тело обновилось изнутри. Это не диета — это перезагрузка всего организма.',
  'testimonial3.highlight': '5 дней, которые заменили мне отпуск',

  // Testimonial 4
  'testimonial4.category': 'Детская нутрициология',
  'testimonial4.name': 'Ольга В.',
  'testimonial4.text': 'Мой сын-аллергик теперь ест разнообразно и с удовольствием. София помогла нам выстроить систему питания, которая работает для всей семьи. Больше никаких высыпаний и бесконечных ограничений. Спасибо за возвращение к нормальной жизни!',
  'testimonial4.highlight': 'Больше никаких высыпаний',

  // Testimonial 5
  'testimonial5.category': 'Совместное ведение',
  'testimonial5.name': 'Дарья С.',
  'testimonial5.text': 'Двойная экспертиза — это то, что мне было нужно. Пока Елена разбиралась с моим ЖКТ и гормонами, София выстраивала питание так, чтобы я худела, но лицо не теряло объем. Результат превзошел все ожидания. Я снова чувствую себя собой.',
  'testimonial5.highlight': 'Я снова чувствую себя собой',

  // Testimonial 6
  'testimonial6.category': 'Протокол FMD',
  'testimonial6.name': 'Ирина Н.',
  'testimonial6.text': 'Биохакинг, который реально работает. После протокола я забыла про вечернюю усталость и туман в голове. Чувствую себя на пике формы. Это не просто детокс — это научный подход к омоложению на клеточном уровне.',
  'testimonial6.highlight': 'Забыла про вечернюю усталость и туман в голове',

  // Bottom CTA
  'cta.title': 'Готовы написать свою историю успеха?',
  'cta.description': 'Присоединяйтесь к сотням клиентов, которые уже изменили свою жизнь с нашей помощью',
  'cta.button': 'Записаться на бесплатную диагностику',
};